
/** 模块状态 */
export class P1 {
    public refresh: string = '';
    public expand: boolean = false;
    public modal: boolean = false;
    public list: any = [];
    public pageSize: number = 20;
    public total:number;
    public fields: any = null;
    public filter: any = null;
    public pageNum: number = 1;
    public hasMore: boolean = true;
    public loading: boolean = false;
}
export class P2 {
    public data: any = null;
    public pageSize: number = 20;
    public pageNum: number = 1;
    public passState: any = {};
    public countData: any = {};
    confirmLoading:boolean=false;
    confirmHasMore:boolean=true;
}
export default class RecordState {
    public p1 = new P1();
    public p2 = new P2();
    public modal: boolean = false;
    public expand: boolean = false;
}



// WEBPACK FOOTER //
// ./src/display/apps/AuthManage/Modules.State.record.ts